// import React, { useEffect, useState } from "react";
// import styles from "./styles.module.scss";
// import DonutChart from "../../../../atoms/DoughnutChart";
// import { ArrowRight, ArrowRightToLine } from "lucide-react";
// import { formatHoursToHm } from "../../../../../helpers/formatTime";
// import NoContentCard from "../../../../atoms/NoContentCard";
// import Modal from "../../../../organisms/modals/Modal";
// import CustomDatagrid from "../../../../organisms/CustomDatagrid";
// import { v4 as uuidv4 } from "uuid";


// const CustomNoRowsOverlay = () => (
//   <NoContentCard
//     title="No Projects Found"
//     type="Project"
//     subtitle="You haven’t started any projects yet. Create one to get going!"
//   />
// );


// const PieCharts = ({ title, data , id }) => {

//   const [isModalOpen , setIsModalOpen] = useState()

//   const modalId = uuidv4();

//   const chartData = data || [];
//   const totalHours = chartData.reduce(
//         (sum, item) => sum + (item?.value || 0),
//         0
//       );
    
//       // const findpercent = (item) => {
//       //   if (!item || totalHours <= 0) return '0.00';
//       //   const percentage = (item / totalHours) * 100;
//       //   return parseFloat(percentage.toFixed(2));
//       // };
    
//       const getHeaderName = (title) => {
//         console.log("This is the title :",title);
//         return title === "Projects Analysis" ? "Project" : "Client";
//       };
    
//       const tableRows = chartData.map((item, index) => ({
//         id: index,
//         taskTitle: item.name,
//         totalTime: item.value,
//         percentage: totalHours > 0 
//           ? ((item.value / totalHours) * 100).toFixed(2)
//           : '0.00'
//       }));
    
//       const columns = [
//         { 
//           field: "taskTitle", 
//           headerName: getHeaderName(title),
//           flex: 1,
//           disableColumnMenu: true
//         },
//         { 
//           field: "totalTime", 
//           headerName: "Logged Time", 
//           flex: 1,
//           disableColumnMenu: true,
//            renderCell: (params) => (
//                  <>
//                  {formatHoursToHm(params?.row?.totalTime)}
//                  </>
//                 )
//         },
//         { 
//           field: "percentage", 
//           headerName: "Percentage", 
//           flex: 1,
//           disableColumnMenu: true,
//           renderCell: (params) => (
//             <>
//             {`${params?.row?.percentage}%`}
//             </>
//            )
//         }
//       ];


//   return (
//     <div className={styles.graph_container} id={id} >
//       <h3 className={styles.title}>{title}</h3>
//       <DonutChart data={data} id={id} />
//       <div className="d-flex align-items-center report-feature-button">
//          <span onClick={()=>setIsModalOpen(true)} className={styles.group_titles} >View Details</span>
//          <ArrowRight color="#6C5DD3" size={18}/>
         
//       </div>

//       {isModalOpen && (
//         <Modal
//           id={modalId}
//           title={title}
//           isActive={isModalOpen}
//           onClose={()=>setIsModalOpen(false)}
//           width="800px"
//           maxHeight="600px"
//           paddingProp="8px"
//           extrastyle={{ 
//             overflow: "hidden auto", 
//             paddingTop: "2px",
//             height: "700px", 
//           }}
//         >
//           <CustomDatagrid
//               rows={tableRows}
//               columns={columns}
//               isLoading={false}
//               isLoadingStateProvided={true}
//               slots={{
//                 noRowsOverlay: CustomNoRowsOverlay
//               }}
//               sx={{
//                 border: "none",
//                 '& .MuiDataGrid-cell:focus': { outline: 'none' },
//                 height: '100%'
//               }}
//             />
//         </Modal>
//       )}


//     </div>
//   );
// };

// export default PieCharts;


import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import DonutChart from "../../../../atoms/DoughnutChart";
import { ArrowRight } from "lucide-react";
import { formatHoursToHm } from "../../../../../helpers/formatTime";
import NoContentCard from "../../../../atoms/NoContentCard";
import Modal from "../../../../organisms/modals/Modal";
import CustomDatagrid from "../../../../organisms/CustomDatagrid";
import { v4 as uuidv4 } from "uuid";

const CustomNoRowsOverlay = () => (
  <NoContentCard
    title="No Projects Found"
    type="Project"
    subtitle="You haven't started any projects yet. Create one to get going!"
  />
);

const PieCharts = ({ title, data, id }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const modalId = uuidv4();

  const chartId = `${id}-chart`;
  const tableId = `${id}-table`;

  const chartData = data || [];
  const totalHours = chartData.reduce(
    (sum, item) => sum + (item?.value || 0),
    0
  );

  const getHeaderName = (title) => {
    return title === "Projects Analysis" ? "Project" : "Client";
  };

  const tableRows = chartData.map((item, index) => ({
    id: index,
    taskTitle: item.name,
    totalTime: item.value,
    percentage: totalHours > 0 
      ? ((item.value / totalHours) * 100).toFixed(2)
      : '0.00'
  }));

  const columns = [
    { 
      field: "taskTitle", 
      headerName: getHeaderName(title),
      flex: 1,
      disableColumnMenu: true
    },
    { 
      field: "totalTime", 
      headerName: "Logged Time", 
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => (
        <>{formatHoursToHm(params?.row?.totalTime)}</>
      )
    },
    { 
      field: "percentage", 
      headerName: "Percentage", 
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => (
        <>{`${params?.row?.percentage}%`}</>
      )
    }
  ];

  return (
    <div 
      className={styles.graph_container} 
      // Add explicit dimensions to help with capture
      style={{ 
        width: '100%', 
        minHeight: '300px',
        position: 'relative',
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        padding: '16px',
        marginBottom: '20px'
      }}
    >
      <h3 className={styles.title}>{title}</h3>
      <div id={chartId}  style={{ minHeight: '300px', width: '100%' }}>
        <DonutChart data={data} />
      </div>
      <div 
        id={tableId} 
        style={{ 
          display: 'none',  // Hidden by default
          width: '100%', 
          backgroundColor: '#ffffff',
          padding: '16px'
        }}
      >
        <h3>{title} - Details</h3>
        <CustomDatagrid
          rows={tableRows}
          columns={columns}
          isLoading={false}
          isLoadingStateProvided={true}
          slots={{
            noRowsOverlay: CustomNoRowsOverlay
          }}
          sx={{
            border: "none",
            '& .MuiDataGrid-cell:focus': { outline: 'none' },
            height: '400px'
          }}
        />
      </div>
      <div className="d-flex align-items-center report-feature-button">
        <span onClick={() => setIsModalOpen(true)} className={styles.group_titles}>View Details</span>
        <ArrowRight color="#6C5DD3" size={18}/>
      </div>

      {isModalOpen && (
        <Modal
          id={modalId}
          title={title}
          isActive={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          width="800px"
          maxHeight="600px"
          paddingProp="8px"
          extrastyle={{ 
            overflow: "hidden auto", 
            paddingTop: "2px",
            height: "700px", 
          }}
        >
          <CustomDatagrid
            rows={tableRows}
            columns={columns}
            isLoading={false}
            isLoadingStateProvided={true}
            slots={{
              noRowsOverlay: CustomNoRowsOverlay
            }}
            sx={{
              border: "none",
              '& .MuiDataGrid-cell:focus': { outline: 'none' },
              height: '100%'
            }}
          />
        </Modal>
      )}
    </div>
  );
};

export default PieCharts;